import { useQuery } from "@tanstack/react-query";
import { TrainIdentifier } from "@vygruppen/vy-train-map";
import { getBackendUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";
import { InfrastructureResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/responseSchema";
import { trainIdKey } from "features/VehicleSidebar/AffectedTrains/utils/utils";

export type GroupedInformationResponse = {
  directlyAffecting: Array<InfrastructureResponse>;
  rest: Array<InfrastructureResponse>;
};

export const useInfrastructureInformationForTrain = (
  train: TrainIdentifier,
) => {
  const { nominalDate, identifier, countryCode } = train;
  const { data, status, refetch } = useQuery({
    queryKey: ["operationalInformationForTrain", trainIdKey(train)],
    queryFn: async ({ signal }: { signal: AbortSignal }) => {
      const res = await queryFnGET<GroupedInformationResponse>({
        signal,
        url: `${getBackendUrl()}/infrastructure-event/train/${nominalDate}/${identifier}/${countryCode}`,
      });
      return res;
    },
  });

  return { status, data, refetch };
};
